<template>
    <div class="">

        <ctlHomeNav></ctlHomeNav>
        <!-- <v-layout>
            <v-flex xs12 class="text-xs-center">
                <v-btn large @click.prevent="newQuote()" class="secondary" >Start a New Quote</v-btn>
            </v-flex>

        </v-layout> -->
        <v-layout row v-if="error">
            <v-flex xs12>
                <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
            </v-flex>
        </v-layout>     
        <v-container fluid >
            <v-layout align-start>
                <v-flex xs12>
                    <v-card class="elevation-12" v-if="discountQuotes.length">
                      <v-toolbar dark color="secondary">
                          <v-spacer></v-spacer>
                          <v-toolbar-title>Approve Discount</v-toolbar-title>
                          <v-spacer></v-spacer>
                      </v-toolbar>
                      <v-card-text v-if="discountQuotes.length">

                          <ctlQuoteListCardView 
                              class="hidden-sm-and-up"
                              :quotes="discountQuotes"
                              @viewQuote="viewQuoteForDiscountApproval"
                              ></ctlQuoteListCardView>
                          <ctlQuoteListTableView 
                              class="hidden-xs-only"
                              :quotes="discountQuotes"
                              @viewQuote="viewQuoteForDiscountApproval"
                              ></ctlQuoteListTableView>
                          <!-- <div class="text-xs-center">
                              <v-pagination
                              v-model="searchCriteria.page"
                              :length="pages"
                              circle
                              ></v-pagination>
                          </div> -->
                      </v-card-text>
                      <v-card-text v-else>
                          <v-layout row>
                              <v-alert value="true" color="warning" body-2 outline>No Record Found</v-alert>
                          </v-layout>
                      </v-card-text>

                    </v-card>
                </v-flex>
            </v-layout>
        
            <v-layout align-start>
                <v-flex xs12>
                    <v-card class="elevation-12">
                    <v-toolbar dark color="secondary">
                        <v-spacer></v-spacer>
                        <v-toolbar-title>Open Quotes</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        <ctlQuoteSearchFilterOpenQuotes @onSearchParamsChanged="onSearchParamsChanged"></ctlQuoteSearchFilterOpenQuotes>
                    </v-card-text>
                    <v-card-text v-if="quotes.length">

                        <ctlQuoteListCardView 
                            class="hidden-sm-and-up"
                            :quotes="quotes"
                            @viewQuote="viewQuote"
                            ></ctlQuoteListCardView>
                        <ctlQuoteListTableView 
                            class="hidden-xs-only"
                            :quotes="quotes"
                            @viewQuote="viewQuote"
                            ></ctlQuoteListTableView>
                        <div class="text-xs-center">
                            <v-pagination
                            v-model="searchCriteria.page"
                            :length="pages"
                            circle
                            ></v-pagination>
                        </div>
                    </v-card-text>
                    <v-card-text v-else>
                        <v-layout row>
                            <v-alert value="true" color="warning" body-2 outline>No Record Found</v-alert>
                        </v-layout>
                    </v-card-text>

                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>

        <!-- {{userData}} -->
        <!-- {{searchCriteria}} -->
    </div>


</template>
<script>
// import _ from 'lodash'
// import jobTypeApi from '@/api/jobTypeApi'
import ctlQuoteSearchFilterOpenQuotes from '@/components/ctlQuoteSearchFilterOpenQuotes'
import ctlQuoteListCardView from '@/components/ctlQuoteListCardView'
import ctlQuoteListTableView from '@/components/ctlQuoteListTableView'
import ctlHomeNav from '@/components/ctlHomeNav'
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
    components: {
        'ctlQuoteSearchFilterOpenQuotes': ctlQuoteSearchFilterOpenQuotes,
        'ctlQuoteListCardView': ctlQuoteListCardView,
        'ctlQuoteListTableView': ctlQuoteListTableView,
        'ctlHomeNav': ctlHomeNav
        },
    data: () => ({
        searchCriteria: {
            // statusSelected: [1, 5],
            // jobTypeSelected: 0
        },
        pages: null,
        quotes: [],
        showAddNew: true,
        discountQuotes: [],
    }),
    computed: {
        ...mapGetters('auth',[
            'loggedIn',
            'userData',
            'userHasPublicRole',
            'userHasInternalRole',
            'userHasSalesQuoteManagerRole',
        ]),
        userIsAuthenticated () {
            // return this.$store.getters.userIsAuthenticated
            return this.loggedIn
        },
        // user () {
        //     // return this.$store.getters.user
        //     return this.userData
        // },
        // jobs () {
            //     return this.$store.getters.loadedJobs
        // },
        error () {
            return this.$store.getters.error
        },
        loading () {
            return this.$store.getters.loading
        }
    },
    watch: {
        searchCriteria: {
            handler: async function (newVal, oldVal) {
                console.log(`${newVal.page} === ${oldVal.page}`)
                // if page not changes, it means the search fired from other search filters
                // so I need reset page = 1
                if(oldVal && newVal.page === oldVal.page) {
                    // newVal.page = 1
                }
                await this.searchQuotes()
            },
            deep: true
        },
        userIsAuthenticated (value) {
            if (!value) {
                this.$router.push('/')
            }
        }
    },
    methods: {
        ...mapActions('pubQuoteSearch',[
            'searchQuotesForSalesRep',
            'searchQuotesForApproval'
        ]),
        ...mapMutations('pubQuoteSearch',[
            'setUserQuoteSearchParams'
        ]),
        async onSearchParamsChanged (paras) {
            this.searchCriteria = Object.assign({}, paras)
            
        },
        async searchQuotes () {
            const searchResult = await this.searchQuotesForSalesRep(this.searchCriteria)
            this.quotes = searchResult.records
            this.pages = searchResult.pageCount
            // this.setUserQuoteSearchParams(this.searchCriteria)
        },
        async getQuotesForApproval () {
            const searchResult = await this.searchQuotesForApproval(this.searchCriteria)
            this.discountQuotes = searchResult.records
            this.pages = searchResult.pageCount
        },
        jobColor (jobStatus) {
            if (jobStatus === 'Cancelled') {
                return 'red--text lighten-3'
            }
            if (jobStatus === 'Lost') {
                return 'red--text lighten-3'
            }
            if (jobStatus === 'NeedMoreInfo') {
                return 'orange--text lighten-3'
            }
            if (jobStatus === 'Editing') {
                return 'blue--text lighten-3'
            }
            if (jobStatus === 'Processing' 
                || jobStatus === 'DiscountApproved') {
                return 'blue--text lighten-3'
            }
            if (jobStatus === 'Revising') {
                return 'blue--text lighten-3'
            }
            if (jobStatus === 'Won') {
                return 'green--text lighten-3'
            }
            if (jobStatus === 'SentToCustomer') {
                return 'purple--text lighten-3'
            }
            if (jobStatus === 'WaitingForProcess') {
                return 'blue--text lighten-3'
            }
        },
        viewQuote: function (id) {
            // console.table(job)
            if(this.userHasInternalRole) {
                this.$router.push({ name: 'int-quote-board', params: { id: id } })
            }
            //20200625, add for International Territory Rep
            else if(this.userHasSalesQuoteManagerRole){
                this.$router.push({ name: 'int-quote-board', params: { id: id } })
            }
            else {
                this.$router.push({ name: 'pub-quote-board', params: { id: id } })

            }
        },
        //regional manager need to see full board page to approve discount. so give this view
        viewQuoteForDiscountApproval: function (id) {
            this.$router.push({ name: 'int-quote-board', params: { id: id } })
        },
        newQuote: function () {
            // console.log('open pub-quote-new')
            this.$router.push({ name: 'pub-quote-new' })
        },
        onDismissed () {
            // console.log('onDismissed alert')
            // this.$store.dispatch('clearError')
        }
    },
    created: async function () {

    },
    mounted: async function () {
        await this.getQuotesForApproval()
        // this.searchQuotes()
        console.log('this.userHasInternalRole' + this.userHasInternalRole)
        console.log('this.userHasPublicRole' + this.userHasPublicRole)

    },

    destroyed: function () {
        this.onDismissed()
    }
}
</script>